/* Live Google rating + review count (2026-11-03). The page renders the numbers saved in Shopify (shop metafields
   tds_google.rating / count); this swaps in Google's current numbers from the Places API (New), cached 6h per visitor.
   Config comes from <html> data set by snippets/tds-greviews-badge.liquid / sections/tds-google-reviews.liquid. */
(function () {
  if (window.__tdsGRating) return; window.__tdsGRating = 1;
  var cfg = document.querySelector('[data-g-key][data-g-place]');
  if (!cfg) return;
  var key = cfg.getAttribute('data-g-key'), place = cfg.getAttribute('data-g-place');
  if (!key || !place) return;
  var LS = 'tds_g_rating_v1', TTL = 6 * 3600 * 1000;

  function fmt(r) { r = Math.round(r * 10) / 10; return r.toFixed(1); }
  function apply(d) {
    if (!d || !d.c) return;
    document.querySelectorAll('[data-g-rating]').forEach(function (el) { el.textContent = fmt(d.r); });
    document.querySelectorAll('[data-g-count]').forEach(function (el) { el.textContent = d.c; });
    document.querySelectorAll('[data-g-label]').forEach(function (el) {
      el.setAttribute('aria-label', 'Rated ' + fmt(d.r) + ' out of 5 from ' + d.c + ' Google reviews');
    });
    document.querySelectorAll('[data-g-stars] i').forEach(function (el, i) {
      el.classList.toggle('is-off', (i % 5) + 1 > Math.floor(Math.round(d.r * 10) / 10));
    });
  }
  var cached = null;
  try { cached = JSON.parse(localStorage.getItem(LS) || 'null'); } catch (e) {}
  if (cached && cached.t && Date.now() - cached.t < TTL) { apply(cached); return; }
  fetch('https://places.googleapis.com/v1/places/' + encodeURIComponent(place) + '?fields=rating,userRatingCount&key=' + encodeURIComponent(key))
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (j) {
      if (!j || !j.userRatingCount) return;
      var d = { r: j.rating, c: j.userRatingCount, t: Date.now() };
      try { localStorage.setItem(LS, JSON.stringify(d)); } catch (e) {}
      apply(d);
    })
    .catch(function () {});
})();
